var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/search-icon.j2"] = require( "header/search-icon.j2" );
dependencies["header/search-form.j2"] = require( "header/search-form.j2" );
dependencies["enhanced-sayt.j2"] = require( "enhanced-sayt.j2" );
dependencies["core-sayt.j2"] = require( "core-sayt.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/search.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/search.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
output += "\n\n<div class=\"dom-site-search\" role=\"search\">\n    ";
env.getTemplate("header/search-icon.j2", false, "core/templates/header/search.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    ";
output += "\n    <div id=\"u-search-anchor\" class=\"c-site-search js-site-search ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"sayt")),"header")),"isClearable")) {
output += "is-clearable";
;
}
output += "\">\n\n        <form novalidate action=\"";
output += runtime.suppressValue((lineno = 8, colno = 43, runtime.callWrap(t_4, "searchUrl", context, [])), env.opts.autoescape);
output += "\" class=\"c-site-search__form js-site-search__form\" method=\"get\">\n\n            ";
env.getTemplate("header/search-form.j2", false, "core/templates/header/search.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
var t_13;
t_13 = "header";
frame.set("source", t_13, true);
if(frame.topLevel) {
context.setVariable("source", t_13);
}
if(frame.topLevel) {
context.addExport("source", t_13);
}
if((lineno = 14, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.enhancedSayt.enabled"])) == runtime.contextOrFrameLookup(context, frame, "True")) {
output += "\n\n                ";
env.getTemplate("enhanced-sayt.j2", false, "core/templates/header/search.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n            ";
})});
}
else {
output += "\n            \n                ";
env.getTemplate("core-sayt.j2", false, "core/templates/header/search.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n            ";
})});
}
output += "\n\n        </form>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/search.j2"] , dependencies)